export const OBRA_DETAIL_TITLE = "Detalhamento Financeiro da Obra";
export const GERAR_FICHA_OBRA_LABEL = "Ficha Financeira da Obra";
export const ABA_EM_BREVE_TITLE = "Disponível em uma próxima entrega.";

/** Abas do detalhamento: só "Planejamento e Controle" existe nesta entrega (as demais são outras HUs). */
export const OBRA_DETAIL_ABAS = [
  { titulo: "Visão Geral", ativa: false },
  { titulo: "Planejamento e Controle", ativa: true },
  { titulo: "Estaleiro e Facilidades", ativa: false },
  { titulo: "Cenários", ativa: false },
  { titulo: "Parâmetros da Obra", ativa: false },
] as const;

export const OBRA_DETAIL_ABA_ATIVA = 1;

export const OBRA_DETAIL_SECAO_LABEL = "Seções do detalhamento";
/** Seletor de seções do mobile, no padrão do detalhe da embarcação ("Seção: Base Técnica"). */
export const OBRA_DETAIL_SECAO_PREFIX = "Seção:";
